import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Grid,
  Paper,
  Typography,
} from "@mui/material";

import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import useTheme from "../../hooks/useTheme";
import NavbarLanguagesDropdown from "../../components/navbar/NavbarLanguagesDropdown";
import { Link } from "react-router-dom";
import MicrosoftIcon from "../../icons/MicrosoftIcon";

const Wrapper = styled(Paper)`
  padding: 0;
  margin: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${(props) => props.theme.sidebar.header.background};
`;

function SignIn() {
  const { t } = useTranslation();

  const { msalLogin } = useAuth();
  const { theme } = useTheme();

  return (
    <Wrapper>
      <Helmet title={t("Sign in")!} />

      {/* <SignUpComponent /> */}

      <Grid container height="100%" width="100%">
        <Grid
          size={{ sm: 12, md: 6, lg: 4 }}
          sx={{
            backgroundColor: "background.paper",
            alignContent: "center",
          }}
          py={(theme) => theme.spacing(10)}
          px={(theme) => theme.spacing(20)}
        >
          <Grid
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap={3}
          >
            <img
              src="/static/img/logo/horizontal_logo.svg"
              style={{
                maxHeight: "60px",
              }}
            />

            <div
              data-o-auth="1"
              data-mode="embed"
              data-widget-mode="login"
              style={{ width: "100%", height: "100%" }}
            ></div>

            <div>
              <Typography variant="body2" align="center">
                {t("Don't have an account?")}&nbsp;
                <Link to="/auth/sign-up">{t("Sign up")}</Link>
              </Typography>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                width: "100%",
                paddingTop: 40,
              }}
            >
              <Alert severity="info" sx={{ mt: 2 }} variant="outlined">
                <AlertTitle>
                  {t("Do you have a Microsoft 365 account?")}
                </AlertTitle>
                {t("Contact us to link your accounts")}
                <div>
                  <Button
                    disabled={false}
                    aria-label="Microsoft 365"
                    variant="outlined"
                    size="large"
                    name="loginProvider"
                    onClick={() => {
                      msalLogin();
                    }}
                    startIcon={<MicrosoftIcon />}
                    sx={{ marginTop: 2 }}
                  >
                    <Typography variant="button" sx={{ textAlign: "center" }}>
                      {t("Continue with Microsoft 365 Account")}
                    </Typography>
                  </Button>
                </div>
              </Alert>
            </div>

            {/* <SignInComponent /> */}

            <NavbarLanguagesDropdown />
          </Grid>
        </Grid>

        <Grid
          size={{ sm: 12, md: 6, lg: 8 }}
          sx={{
            // hide on small screens
            display: { xs: "none", sm: "none", md: "block", lg: "block" },
          }}
        >
          <Box
            sx={{
              backgroundImage: `url("/static/img/backgrounds/2.jpg")`,
              height: "100%",
              width: "100%",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          />
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default SignIn;
